import React from "react";
import toast from "react-hot-toast";
import { createSearchParams, Link } from "react-router-dom";
import { cities } from "../../../../Utils/contstant";
import Loading from "../../../Common/Loading";
import { useReserve } from "../Hooks";

const Cities = ({ loading }) => {
  const { navigate } = useReserve();
  if (loading) {
    return (
      <div className="row justify-content-between">
        <Loading count={7} height={100} />
      </div>
    );
  }

  return (
    <div
      className=" mt-4 citis mb-4"
      style={
        {
          // justifyContent:
          //   window.innerWidth > 650 ? "space-evenly" : "space-between",
        }
      }
    >
      {cities.map(pic => {
        return (
          <Link
            className="city"
            style={{
              // width: window.innerWidth > 650 ? "10%" : "20%",
              cursor: "pointer",
            }}
            to={pic.id ? `${pic.route}` : ""}
          >
            <div className="city-box">
              <div className="city-effect"></div>
              <div className="city-img">
                <img src={window.origin + `/img/city/${pic.imgSrc}.png`} />
              </div>

              <div className="city-content" style={{}}>
                <h5 style={{}}>{pic.name}</h5>
                <span style={{}}>({pic.status})</span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default Cities;
